import { render, staticRenderFns } from "./ItemSelectionModal.vue?vue&type=template&id=3fad695d&"
import script from "./ItemSelectionModal.vue?vue&type=script&lang=ts&"
export * from "./ItemSelectionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fad695d')) {
      api.createRecord('3fad695d', component.options)
    } else {
      api.reload('3fad695d', component.options)
    }
    module.hot.accept("./ItemSelectionModal.vue?vue&type=template&id=3fad695d&", function () {
      api.rerender('3fad695d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/ItemSelectionModal.vue"
export default component.exports